<template>
  <div class="container">
    <app-header title="个人信息"></app-header>
    <div class="main">
      <van-form @submit="onSubmit">

        <div class="image">
          <div class="title">头像</div>
          <div class="content">
            <div class="item">
              <van-uploader :after-read="afterRead" :accept="'image/*'">
                <img :src="form.avatar" alt="图片" class="imgPreview">
              </van-uploader>
            </div>
          </div>
        </div>

        <van-field
          v-model="form.name"
          name="昵称"
          label="昵称"
          placeholder="昵称"
          input-align="right"
          :rules="[{ required: true, message: '请填写昵称' }]"
        />

        <van-field
          v-model="form.phone"
          name="手机号"
          label="手机号"
          placeholder="手机号"
          input-align="right"
          :rules="[{ required: true, message: '请填写手机号' }]"
        />
        <van-field
                   v-model="form.phoneCode"
                   name="验证码"
                   label="验证码"
                   placeholder="请输入验证码"
                   :rules="[{ required: true, message: '请输入验证码' }]">
          <template #button>
            <van-button :disabled="disabled"
                        @click="getcode"
                        class="panel"
                        size="small"
                        type="default">{{time}}</van-button>
          </template>
        </van-field>


        <van-button class="submit" native-type="submit">
          提交
        </van-button>

      </van-form>
    </div>
  </div>
</template>

<script>
  import {image} from '@/api/file'
  import {updateShopUser, findByShopUser} from '@/api/mine/getUser'
  import { getNOteCode } from '@/api/login/index.js'

  export default {
    name: "info",
    data() {
      return {
        uploader: [{url: 'https://img.yzcdn.cn/vant/leaf.jpg'}],
        id: '',
        disabled: false,
        time: '获取验证码',
        form: {
          id: '',
          name: '',
          avatar: ''
        }
      };
    },
    created() {
      var user = JSON.parse(localStorage.getItem('userInfo'))
      if (!user) {
        this.$router.push({ path: '/login' })
        return;
      }
      this.id = JSON.parse(user.id)
      this.getUser()
    },
    methods: {
      gettime () {
        if (this.time == 0) {
          // 清除js定时器
          clearInterval(this.close)
          this.time = '获取验证码'
          this.disabled = false
        } else {
          this.time--
        }
      },
      getcode () {
        if(!this.form.phone) {
          this.$toast.fail('输入手机号')
          return;
        }
        const params = {
          phone: this.form.phone
        }
        this.disabled = true
        getNOteCode(params).then((res) => {
          console.log(res.success)
          if (res.success) {
            this.time = 60
            this.close = setInterval(this.gettime, 1000)
          } else {
            this.disabled = false
          }
        })
      },
      afterRead(file) {
        this.upload(file);
      },
      upload(file) {
        let formData = new FormData()
        formData.append('file', file.file)
        image(formData).then(res => {
          console.log(res);
          if (res.success) {
            this.form.avatar = res.data
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {

        })
      },
      getUser() {
        findByShopUser({id: this.id}).then(res => {
          if (res.success) {
            this.form.name = res.data.name
            this.form.avatar = res.data.avatar
          }
        })
      },
      onSubmit() {
        this.form.id = this.id
        updateShopUser(this.form).then(res => {
          if (res.success) {
            this.$toast.success("提交成功！")
            this.$router.push('/mine')
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .container {
    .main {
      /deep/ .van-field__error-message {
        text-align: right !important;
      }
      .tip {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: red;
        padding: 12px 0;
        margin-left: 16px;
      }
      .image {
        padding: 10px 16px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 16px;
        overflow: hidden;
        .title {
          width: 90px;
          line-height: 90px;
        }
        .content {
          flex: 1;
          .item {
            float: right;
            display: block;
            width: 80px;
            height: 80px;
            border-radius: 8px;
            position: relative;
            cursor: pointer;
            .imgPreview {
              width: 80px;
              height: 80px;
            }

          }
        }
      }
      .submit {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 50px;
        color: rgba(255, 255, 255, 1);
        background: linear-gradient(0deg, #f40442 0%, rgba(226, 23, 75, 0.73) 100%);
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/user/info.vue